import { Injectable } from '@angular/core';
import { DatabaseService, EventsName } from 'app/services/database/database.service';
import { Observable } from 'rxjs';

@Injectable()
export abstract class Repository<T> {
    protected abstract get path(): string;

    constructor(protected db: DatabaseService) { }

    public async exists(key: string): Promise<boolean> {
        return await this.db.exists(this.path, key);
    }

    public async get(key: string): Promise<T> {
        return await this.db.get<T>(this.path, key);
    }

    public async push(value: T): Promise<T> {
        value = this.nullify(value, false);
        value = this.rectifyDate(value);
        return await this.db.push<T>(this.path, value);
    }

    public async update(key: string, value: T) {
        value = this.nullify(value, false);
        value = this.rectifyDate(value);
        await this.db.update<T>(this.path, key, value);
    }

    public async set(key: string, value: T) {
        value = this.nullify(value, false);
        value = this.rectifyDate(value);
        await this.db.set<T>(this.path, key, value);
    }

    public async remove(key: string) {
        await this.db.remove<T>(this.path, key);
    }

    public async generateKey(): Promise<string> {
        return (await this.db.push()).key;
    }

    public watch(eventName: EventsName, key: string): Observable<T> {
        return this.db.watch(eventName, this.path, key);
    }

    public watchOnce(eventName: EventsName, key: string): Promise<T> {
        return this.db.watchOnce(eventName, this.path, key);
    }

    private nullify(value: any, deleteEmpty: boolean) {
        for (let prop in value) {
            if (value.hasOwnProperty(prop)) {
                let val = value[prop];
                if (this.isEmpty(val)) {
                    if (deleteEmpty) {
                        delete value[prop];
                    } else {
                        value[prop] = null;
                    }
                } else if (typeof val === 'object') {
                    value[prop] = this.nullify(val, deleteEmpty);
                }
            }
        }
        return value;
    }

    private isEmpty(val: any): boolean {
        return val === undefined ||
            val === null ||
            val === '';
    }

    private rectifyDate(value: any) {
        for (let prop in value) {
            if (value.hasOwnProperty(prop)) {
                let val = value[prop];
                if (val instanceof Date) {
                    value[prop] = val.getTime();
                } else if (typeof val === 'object') {
                    value[prop] = this.rectifyDate(val);
                }
            }
        }
        return value;
    }

}



// WEBPACK FOOTER //
// ./src/app/services/database/repository.ts